import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableCm6PackingSlipEditor = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableCm6PackingSlipEditor);
};
